module.exports = __webpack_public_path__ + "static/media/025.2a4b0d60.jpg";